<template>
  <div class="staged-rollout-slider">
    <ElSlider
      class="staged-rollout-slider__percentage"
      :value="percentage"
      :step="step"
      :min="0"
      :max="100"
      :format-tooltip="makeSliderTooltip"
      :marks="sliderStopsLabels"
      @input="setPercent"
    />
  </div>
</template>

<script>
import { APP_DETAILS } from '@/store/types';
import { mapGetters } from 'vuex';

const DEFAULT_START = 5;
const DEFAULT_STEP = 5;

export default {
  name: 'StagedRolloutSlider',
  props: {
    initialPercentage: {
      type: Number,
      default: null,
    },
    percentage: {
      type: Number,
      required: true,
    },
    canDecrease: {
      type: Boolean,
      default: false,
    },
    start: {
      type: Number,
      default: DEFAULT_START,
    },
    step: {
      type: Number,
      default: DEFAULT_STEP,
    },
  },
  computed: {
    ...mapGetters({ app: APP_DETAILS }),
    sliderStopsLabels() {
      const labels = {};
      for (let i = 0; i <= 100; i += 10) {
        labels[i] = `${i}%`;
      }
      return labels;
    },
    minimumValidPercent() {
      return this.initialPercentage || this.start;
    },
  },
  methods: {
    setPercent(value) {
      if (this.canDecrease) {
        const correctValue = Math.max(this.start, value);
        this.$emit('update:percentage', correctValue);
      } else {
        const correctValue = Math.max(this.minimumValidPercent, value);
        this.$emit('update:percentage', correctValue);
      }
    },
    makeSliderTooltip(percent) {
      if (percent < this.start) {
        return this.$t('APP.RELEASES.STAGED_ROLLOUT.MIN_VALUE', {
          minValue: this.start,
        });
      }

      if (percent === 100) {
        return this.$t('APP.RELEASES.STAGED_ROLLOUT.ALL_USERS');
      }

      if (!this.canDecrease && percent < this.minimumValidPercent) {
        return this.$t('APP.RELEASES.STAGED_ROLLOUT.NO_DECREASE');
      }

      const activeUsers = Number(this.app.activeInstallCount) || 0;
      const users = Math.ceil((activeUsers * (percent / 100)) / 50) * 50;

      return this.$t('APP.RELEASES.STAGED_ROLLOUT.SLIDER_TOOLTIP', {
        users,
        percent,
      });
    },
  },
};
</script>

<style lang="scss">
.staged-rollout-slider {
  margin-top: $global-margin;
  margin-bottom: $global-margin * 4;
  padding: 0 $global-padding * 0.3;

  &__percentage {
    width: 100%;

    .el-slider__marks-text {
      color: $lb-black;
      font-size: 0.7rem;
    }

    .el-slider__stop {
      background: none;
    }
  }
}
</style>
